var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "frame-background",
    x: 1,
    y: 1,
    width: 62,
    height: 82,
    rx: 3,
    fill: "transparent",
    stroke: "transparent",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10a4 4 0 0 1 4-4h44a4 4 0 0 1 4 4v44a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4z",
    id: "qr-background"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    x: 12,
    y: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text-container"
  }, /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 73.765,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontSize: 9,
    fontWeight: 700,
    fontFamily: "var(--font-frame-default)",
    fill: "#000000"
  }, "Scan me!"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/frame-3.d8eaf63338415559c2e60599c8c6ac5c.svg";
export { ForwardRef as ReactComponent };